<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { RouterLink } from 'vue-router'
import { listCompetitions, type Competition } from '../../api/competitions'
import CCompDetails from '../../components/CCompDetails.vue'
import { useAuthStore } from '../../stores/auth'
import CLoginButton from '../../components/CLoginButton.vue';

const auth = useAuthStore()

const competitions = ref<Competition[]>([])
const loading = ref(true)

const activeComps = computed(() =>
	competitions.value
		.filter(c => c.status === 'accepting_submissions' || c.status === 'running')
		.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())
)

const pastComps = computed(() =>
	competitions.value
		.filter(c => c.status !== 'accepting_submissions' && c.status !== 'running')
		.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())
)

onMounted(async () => {
	competitions.value = await listCompetitions()
	loading.value = false
})
</script>

<template>
	<main class="l-row l-stack">
		<h1>Competitions</h1>

		<p>Here are all of the currently-active competitions.</p>

		<div v-if="auth.user">
			<RouterLink class="c-button" to="/competitions/new">Create a new Competition</RouterLink>
		</div>
		<div v-else>
			If you want to create a new competition, please log into your account!

			<c-login-button/>
		</div>

		<h2>Active Competitions</h2>

		<p v-if="!loading && !activeComps.length">
			There aren't currently any active competitions. <template v-if="auth.user">Want to run one? <RouterLink to="/competitions/new">Click here.</RouterLink></template>
		</p>

		<CCompDetails
			v-for="comp in activeComps"
			:key="comp.id"
			:competition="comp"
		/>

		<h2>Past Competitions</h2>

		<p v-if="!loading && !pastComps.length">Nothing to see here.</p>

		<CCompDetails
			v-for="comp in pastComps"
			:key="comp.id"
			:competition="comp"
		/>
	</main>
</template>
